import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const NormalizePathname = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const normalizedPath = location.pathname.replace(/\/+/g, '/');
  const needsNormalize = normalizedPath !== location.pathname;

  useEffect(() => {
    if (needsNormalize) {
      const target = normalizedPath + location.search + location.hash;
      navigate(target, { replace: true });
    }
  }, [needsNormalize, normalizedPath, location.search, location.hash, navigate]);

  if (needsNormalize) {
    return null;
  }

  return <>{children}</>;
};
